module.exports = __webpack_public_path__ + "f3d00141a9ed56752ed55221108c06be.MP3";